var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24622 6.6705L4.88384 8.0325L4.87409 0H4.12409L4.13384 8.02763L2.77634 6.67013L2.24609 7.2L3.71572 8.66963C3.82019 8.77411 3.94421 8.857 4.08072 8.91354C4.21722 8.97009 4.36353 8.9992 4.51128 8.9992C4.65903 8.9992 4.80534 8.97009 4.94184 8.91354C5.07835 8.857 5.20237 8.77411 5.30684 8.66963L6.77647 7.2L6.24622 6.6705Z",
    fill: "#0A171E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2462 2.3295L10.8838 0.967499L10.8741 9H10.1241L10.1338 0.972374L8.77634 2.32987L8.24609 1.8L9.71572 0.330374C9.82019 0.225887 9.94421 0.143003 10.0807 0.0864553C10.2172 0.0299063 10.3635 0.000801086 10.5113 0.000801086C10.659 0.000801086 10.8053 0.0299063 10.9418 0.0864553C11.0783 0.143003 11.2024 0.225887 11.3068 0.330374L12.7765 1.8L12.2462 2.3295Z",
    fill: "#0A171E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTable);
export default __webpack_public_path__ + "static/media/sort-table.08e5f48d3da11b5bf4d64f8f066400a1.svg";
export { ForwardRef as ReactComponent };